exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-a2a5746e]{width:100%;height:100%;padding:0}.wrapper .banner[data-v-a2a5746e]{width:100%;height:100%;position:relative}.wrapper .banner img[data-v-a2a5746e]{position:absolute;left:0;top:0;width:100%;height:100%;-o-object-fit:fill;object-fit:fill}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a2a5746e","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/user/homeindex.vue
// module id = 4C/U
// module chunks = 1